export const ProfileText={
    'upload':'Click and drag the image (or the corners of the selection box) to reposition and resize the selection to match the area you want to use.'
}